module.exports = __webpack_public_path__ + "img/wired-disconnected.fb25259b.svg";